module.exports = __webpack_public_path__ + "static/media/Henry.65b09bee.png";